import { useState } from 'react'
import { Button, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components'
import { Navigation24Regular } from '@fluentui/react-icons'
import { OverlayDrawerComponent } from '@/ui/OverlayDrawerComponent/OverlayDrawerComponent'
import { ReviewUsersPanel } from './ReviewUsersPanel'
import { RestSchemas } from '@/contexts/QueryProvider'
import { isPlatformAdmin, isSuperUser, isProjectLeader } from '@/util/roles'
import { useSessionStorage } from '@/hooks/useSessionStorage'

type MessagesSubscriptionsOrganisationWorkspace = RestSchemas['Messages.Subscriptions.OrganisationWorkspace']

type RowActionsMenuProps = {
  workspace: MessagesSubscriptionsOrganisationWorkspace
}

export function RowActionsMenu({ workspace }: RowActionsMenuProps) {
  const [drawerOpen, setDrawerOpen] = useState<'none' | 'reviewUsers'>('none')

  // ✅ User can see "Review Users" if they have role 4 (Project Leader), 8 (Platform Admin), or 16 (SuperUser)
  const [userRole] = useSessionStorage('roles', 1)
  const [isWorkspaceAdminsAllowed] = useState(() => {
    return isProjectLeader(userRole) || isPlatformAdmin(userRole) || isSuperUser(userRole)
  })

  return (
    <>
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <Button icon={<Navigation24Regular />} />
        </MenuTrigger>

        <MenuPopover>
          <MenuList>
            {isWorkspaceAdminsAllowed && <MenuItem onClick={() => setDrawerOpen('reviewUsers')}>Review Users</MenuItem>}
          </MenuList>
        </MenuPopover>
      </Menu>

      <OverlayDrawerComponent
        open={drawerOpen === 'reviewUsers'}
        setOpen={(open) => setDrawerOpen(open ? 'reviewUsers' : 'none')}
        title="Review User Access"
        size="medium"
        content={<ReviewUsersPanel workspaceId={workspace.workspaceId} onClose={() => setDrawerOpen('none')} />}
      />
    </>
  )
}
